import React, { Component } from "react";
class Vysledek extends Component {
  render() {
    //console.log("Zobrazuji vysledek");
    return (
      <div className="jumbotron">
        <h1 className="display-4">Hotovo</h1>
        <p className="lead">Váš čas je {this.props.cas}</p>
      </div>
    );
  }
}

export default Vysledek;
